import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef, viewTechDocRouteRef } from './routes';

export const nestleAboutCardPlugin = createPlugin({
  id: 'nestle-about-card',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    viewTechDoc: viewTechDocRouteRef,
  },
});

export const NestleAboutCardPage = nestleAboutCardPlugin.provide(
  createRoutableExtension({
    name: 'NestleAboutCardPage',
    component: () =>
      import('./components/NestleAboutCard').then(m => m.AboutCard),
    mountPoint: rootRouteRef,
  }),
);
